import React, {Component} from 'react';
import {Button, Header, Input} from 'semantic-ui-react';
import {updatePhotoLink} from '../../data/report_api';

class PhotoLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            photoLink: "",
            saved: false
        }
    }

    handleSubmit = () => {
        this.setState({uploading:true});
        let formData = new FormData();
        formData.append("report_id", this.props.reportId);
        formData.append("photo_link", this.state.photoLink);
        updatePhotoLink(formData).then((response) => {
            if (response.success) {
                this.setState({saved: true,uploading:false});
            }
            else {
                this.setState({uploading:false});
            }
        });
    };

    render() {
        return (<div>
            <Header textAlign="left"> Photo Link {this.state.saved && <span className="info-success">Saved!</span>}
                <Button primary compact content="Save" className="pull-right icon-button" onClick={(e) => {
                    this.handleSubmit()
                }}/> </Header>
            <Input key={this.props.photoLink} type="text" placeholder='Reports Photo Collection Link' fluid
                   defaultValue={this.props.photoLink} onChange={(e) => {
                this.setState({photoLink: e.target.value})
            }}
            />
        </div>);
    }
}

export default PhotoLink;


// WEBPACK FOOTER //
// ./src/views/report/photo_link.js